import React from 'react';
import { ObjectArray } from '../Page';
import { ButtonSquare } from '../../../components/design/buttons/Button';
import { BiChevronRight, BiQrScan } from 'react-icons/bi';
import { TbDeviceSim } from 'react-icons/tb';
const SelectType: React.FC<ObjectArray> = ({ onOptionSelect, t , i18n}) => {

    const onClick = (value: any) =>
    {
        const obj = {
            "type": value
        }
        onOptionSelect(obj);
    }


    return (
        <div>
            {/* <h1>{t("local_sim.select_type.title")}</h1>
            <p>{t("local_sim.select_type.description")}</p> */}
            <div className="row mt-5">
                {/* <div className="col-12 col-md-6 mb-4">
                    <ButtonSquare inner={
                        <div className="d-flex align-items-center  gap-2 justify-content-center" style={{flexDirection: "column"}}>
                            <img src="media/landing/topics/icon-1.gif" className="gif" alt="icon" width="32px"/>
                            <span>{t("local_sim.select_type.options.prepaid")}</span>
                        </div>
                    } color="primary-outline-primary p-5" isfullWidth={true} isrounded={true} onClick={() => onClick([1])}></ButtonSquare>
                </div>
                <div className="col-12 col-md-6 mb-4">
                    <ButtonSquare inner={<div className="d-flex align-items-center  gap-2 justify-content-center" style={{flexDirection: "column"}}>
                            <img src="media/landing/topics/icon-2.gif" className="gif" alt="icon" width="32px"/>
                            <span>{t("local_sim.select_type.options.postpaid")}</span>
                        </div>} color="primary-outline-primary p-5" isfullWidth={true} isrounded={true} onClick={() => onClick([2])}></ButtonSquare>
                </div> */}<div className="col-12 mb-4">
                                    <div className='input_bg p-4' onClick={()=>onClick("sim")} style={{cursor: "pointer"}}>
                                        <div className="d-flex align-items-center flex-row gap-2 justify-content-center" style={{flexDirection: "column"}}>
                                            <TbDeviceSim className="icon_det" style={{color: '#3EB6AE', fontSize: '1.5rem'}} />
                                            <span>{t("local_sim.select_type.options.sim")}</span>
                                        </div>
                                        {/* Arrow without tail */}
                                        <BiChevronRight style={{transform: i18n.language == "ar" ? "scaleX(-1)" : "scaleX(1)", fontSize: '1.5rem'}}  size={32}/>
                                    </div>
                                </div>
                           <div className="col-12 mb-4">
                                    <div className='input_bg p-4' onClick={()=>onClick("esim")} style={{cursor: "pointer"}}>
                                        <div className="d-flex align-items-center flex-row gap-2 justify-content-center" style={{flexDirection: "column"}}>
                                            <BiQrScan className="icon_det" style={{color: '#3EB6AE', fontSize: '1.5rem'}} />
                                            <span>{t("local_sim.select_type.options.esim")}</span>
                                        </div>
                                        <BiChevronRight style={{transform: i18n.language == "ar" ? "scaleX(-1)" : "scaleX(1)", fontSize: '1.5rem'}}  size={32}/>
                                    </div>
                                    {/* color="primary-outline-primary p-5 m-0" isfullWidth={true} isrounded={true} ></ButtonSquare> */}
                                </div>
                                
            </div>
        </div>
    );
};

export default SelectType;
 